'use client';

import { useState } from 'react';
import Header from '@/components/common/Header';
import HeroSection from './HeroSection';
import ServiceSelector from './ServiceSelector';
import TestimonialCarousel from './TestimonialCarousel';
import TrustSignals from './TrustSignals';
import IndustryShowcase from './IndustryShowcase';
import ConsultationModal from './ConsultationModal';
import CTASection from './CTASection';
import Footer from './Footer';

const HomepageInteractive = () => {
  const [isConsultationModalOpen, setIsConsultationModalOpen] = useState(false);

  const handleConsultationClick = () => {
    setIsConsultationModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsConsultationModalOpen(false);
  };

  return (
    <>
      <Header />
      <main className="pt-16">
        <HeroSection onConsultationClick={handleConsultationClick} />
        <ServiceSelector />
        <TrustSignals />
        <TestimonialCarousel />
        <IndustryShowcase />
        <CTASection onConsultationClick={handleConsultationClick} />
      </main>
      <Footer />
      <ConsultationModal isOpen={isConsultationModalOpen} onClose={handleCloseModal} />
    </>
  );
};

export default HomepageInteractive;